import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { SessionManager } from '../../../../session/service/session-manager';
import * as moment from 'moment-timezone';
import { BehaviorSubject } from 'rxjs';

interface CreateTimeChange {
  timeFrom?: string;
  timeTo?: string;
  createTime?: string;
  dateTo?: string;
  dateFrom?: string;
}


@Component({
  selector: 'time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements OnInit, OnDestroy {
  @Input() createTime: string = '';
  @Input() placeholder: string = 'Created at';
  @Input() currentDate$: BehaviorSubject<string[]>;
  @Output() createTimeChange: EventEmitter<CreateTimeChange> = new EventEmitter<CreateTimeChange>();
  currentDateFrom: string;
  currentDateTo: string;
  private timeFrom: string;
  private timeTo: string;
  public timeOptions = [];
  private timezone: string;

  constructor(private sessionManager: SessionManager) {
  }

  ngOnInit() {
    // this.createTime = '';
    this.loadUserTimezone();
    if (!this.currentDate$) { return; }
    this.currentDate$.subscribe(val => {
      if (val) {
        this.currentDateFrom = val[0];
        this.currentDateTo = val[1];
        this.timeChanged();
      } else {
        this.createTime = '';
      }
    });
  }

  timeChanged() {
    const today = this.currentDateTo
      ? moment.tz(this.currentDateTo, this.timezone).format('YYYY-MM-DD')
      : moment.tz(new Date(), this.timezone).format('YYYY-MM-DD');

    this.timeFrom = this.createTime
      ? moment.tz(`${today} ${this.createTime}`, this.timezone).format('YYYY-MM-DD HH:mm:ss').split(' ')[1]
      : '';
    this.timeTo = this.createTime
      ? moment.tz(`${today} ${this.createTime}`, this.timezone).add(59.99, 'minutes').format('YYYY-MM-DD HH:mm:ss').split(' ')[1]
      : '';

    let dateTo;
    let dateFrom;
    if (this.currentDateFrom && this.currentDateTo) {
      dateTo = this.createTime
        ? moment.tz(`${this.currentDateTo} ${this.createTime}`, this.timezone).format('YYYY-MM-DD HH:mm:ss').split(' ')[0]
        : '';
      dateFrom = this.createTime
        ? moment.tz(`${this.currentDateFrom} ${this.createTime}`, this.timezone).format('YYYY-MM-DD HH:mm:ss').split(' ')[0]
        : '';
    }

    this.createTimeChange.emit({
      timeFrom: this.timeFrom,
      timeTo: this.timeTo,
      createTime: this.createTime,
      dateTo,
      dateFrom
    });
  }

  resetTime() {
    this.createTime = '';
    this.timeFrom = '';
    this.timeTo = '';
    this.createTimeChange.emit({ timeFrom: this.timeFrom, timeTo: this.timeTo, createTime: this.createTime });
  }

  private fillTimeOptions() {
    const divider = 1;
    const getUSHour = (i: number) => {
      return ('0' + Math.floor((i + (i > 12 ? -12 : 0)) / divider) + ':0' + 60 * (i / divider % 1) + (i > 11 ? ' pm' : ' am')).replace(/\d(\d\d)/g, '$1');
    };
    const getEUHour = (i: number) => {
      return ('0' + Math.floor(i / divider) + ':0' + 60 * (i / divider % 1)).replace(/\d(\d\d)/g, '$1');
    };

    this.timeOptions = Array(24 * divider).fill(0).map((_, i) => {
        return { label: this.has12HourClock() ? getUSHour(i) : getEUHour(i), value: getEUHour(i) };
      },
    );
  }

  private has12HourClock() {
    // const USTimeZones = moment.tz.zonesForCountry('US');
    const USTimeZones = ['America/Adak', 'America/Anchorage', 'America/Boise', 'America/Chicago', 'America/Denver', 'America/Detroit', 'America/Indiana/Indianapolis', 'America/Indiana/Knox', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Tell_City', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Juneau', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Los_Angeles', 'America/Menominee', 'America/Metlakatla', 'America/New_York', 'America/Nome', 'America/North_Dakota/Beulah', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/Phoenix', 'America/Sitka', 'America/Yakutat', 'Pacific/Honolulu'];
    return USTimeZones.includes(this.timezone) || this.timezone.toLowerCase().includes('us/');
  }

  private loadUserTimezone() {
    this.sessionManager.getIdentity()
      .subscribe((user: any) => {
        this.timezone = user.timezone;
        if (!user.timezone) {
          this.timezone = moment.tz.guess();
        }
        this.fillTimeOptions();
      });
  }

  ngOnDestroy() {
    if (this.currentDate$) {
      this.currentDate$.unsubscribe();
    }
  }

}
